import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2;
var ScrollableSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow-x: scroll;\n"])));
var getTruncatedStyles = function getTruncatedStyles(_ref) {
  var $position = _ref.$position;
  if ($position === 'end') {
    return "\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    ";
  }
  return "\n    direction: rtl;\n    white-space: nowrap;\n    text-overflow: clip;\n  ";
};
var TruncatedSpan = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), getTruncatedStyles);

export { ScrollableSpan, TruncatedSpan };
//# sourceMappingURL=Truncated.styles.js.map
